import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		defaultMessage: 'Error',
		id: 'dashboard-edit.services.duplicate-gadget.error-flag-title',
		description:
			'Text in notification flag to alert user that the operation to duplicate gadget has failed',
	},
	errorFlagDescription: {
		defaultMessage: 'We cannot duplicate that gadget at the moment',
		id: 'dashboard-edit.services.duplicate-gadget.error-flag-description',
		description:
			'Text in notification flag to alert user that the operation to duplicate gadget has failed',
	},
	errorFlagAction: {
		defaultMessage: 'Refresh',
		id: 'dashboard-edit.services.duplicate-gadget.error-flag-action',
		description: 'Label for button inside the notification flag to reload the current page',
	},
	successFlagTitle: {
		id: 'dashboard-edit.services.duplicate-gadget.success-flag-title',
		defaultMessage: 'Gadget has been duplicated',
		description:
			'The text is a title shown in a notification flag that appears in the bottom left corner when a user successfully duplicates a gadget',
	},
	successFlagDescription: {
		id: 'dashboard-edit.services.duplicate-gadget.success-flag-description',
		defaultMessage: 'You\'ve successfully duplicated the "{name}" gadget.',
		description:
			'The text is a description shown in a notification flag that appears in the bottom left corner when a user successfully duplicates a gadget',
	},
});
